import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

const COLUMNS = 3;

export const GridContainerStyle = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1, 1, 6, 1),
  display: 'grid',
  gridTemplateColumns: `repeat(${COLUMNS}, minmax(0, 1fr))`,
  columnGap: theme.spacing(1),
  rowGap: theme.spacing(1.5),
  width: '100%',
  paddingBottom: theme.spacing(6),
  boxSizing: 'border-box',
}));

export const GridSlideWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isWide',
})<{ isWide?: boolean }>(({ isWide }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-start',
  width: '100%',
  minWidth: 0,
  gridColumn: isWide ? 'span 2' : undefined,
}));

export const LoadingContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  padding: theme.spacing(2, 0),
}));

export const ListContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isHorizonLayout',
})<{ isHorizonLayout?: boolean }>(({ theme, isHorizonLayout }) => ({
  background: theme.palette.common.white,
  padding: theme.spacing(0),
  width: '100%',
  boxSizing: 'border-box',
  ...(isHorizonLayout && {
    borderRadius: theme.spacing(2),
    overflow: 'visible',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  }),
}));
